/*

  # Scroll tables module

  The `div[data-hook~="scrollTables"]` setting attributes are:

  - `data-table-container`, a class to use on parents of tables
    which is to be applied to the new container.
  
  <div data-hook="scrollTables" data-table-container="contains-tables">
  
  This module is intended to be used on rich text areas but is not limited to them.
  
*/

import { assignController, selectAll } from '../api/element-manipulation'
import { debounce } from '../api/debounce'

assignController('scrollTables', element => {
  selectAll(element, 'table').forEach ( table => {
    const outerWrapper = document.createElement('div')
    outerWrapper.setAttribute('role', 'presentation')
    outerWrapper.className = 'p-relative'
    outerWrapper.dataset.hook = 'overflowShadow'
    const innerWrapper = document.createElement('div')
    innerWrapper.className = `p-relative overflow-x-auto ${element.dataset.tableContainer}`
    innerWrapper.setAttribute('role', 'presentation')
    table.parentNode.insertBefore(outerWrapper, table)
    table.parentNode.removeChild(table)
    innerWrapper.appendChild(table)
    outerWrapper.appendChild(innerWrapper)
  })
})

const controlOverflowShadow = () => {
  selectAll(document, '[data-hook~="overflowShadow"').forEach((outerWrap) => {
    if (outerWrap.children.length > 0) {
      const innerWrap = outerWrap.children[0]
      if (innerWrap.scrollWidth > innerWrap.clientWidth) {
        outerWrap.classList.add('show-overflow-shadow')
      } else {
        outerWrap.classList.remove('show-overflow-shadow')
      }
    }
  })
}
setTimeout(controlOverflowShadow, 1000)
window.addEventListener('resize', debounce(controlOverflowShadow, 100, true))
